<script setup lang="ts">
import { computed } from 'vue';
import Icon from '@components/icons/icon.vue';
import ButtonSquare from '@components/buttons/button-square.vue';
import Button from '@components/buttons/button.vue';
import HorizontalAlignChildrenWrapper from '@components/layout-wrapper/horizontal-align-children-wrapper.vue';

const props = defineProps<{
    maxPage: number,
}>();

const currentPage = defineModel<number>('currentPage', { required: true });

const pageRange = 3;
const pageInitial = 1;

const pages = computed(() => {
    const pages = [];
    let page = 1;
    while (page <= props.maxPage) {
        pages.push(page);
        page++;
    }
    return pages;
});

function previousPage() {
    if (currentPage.value === 1) {
        return;
    }
    currentPage.value -= 1;
}
function nextPage() {
    if (currentPage.value >= props.maxPage) {
        return;
    }
    currentPage.value += 1;
}
</script>

<template>
    <HorizontalAlignChildrenWrapper v-if="maxPage > pageInitial" gap="1" :wrap-on-small-screen="false" grow-children>
        <ButtonSquare v-if="currentPage !== pageInitial" icon="angle-left" @click="previousPage"/>
        <Button :context="currentPage === pageInitial ? 'primary' : 'default'" @click="currentPage = pageInitial">{{ pageInitial }}</Button>
        <span v-if="currentPage > (pageInitial + pageRange)" :class="$style.ellipsis">
            <Icon icon="ellipsis-h"/>
        </span>
        <template v-for="page in pages">
            <Button
                v-if="page !== pageInitial && page !== maxPage && (page < currentPage + pageRange) && (page > currentPage - pageRange)"
                :context="page === currentPage ? 'primary' : 'default'"
                @click="currentPage = page"
            >
                {{ page }}
            </Button>
        </template>
        <span v-if="currentPage < (maxPage - pageRange)" :class="$style.ellipsis">
            <Icon icon="ellipsis-h"/>
        </span>
        <Button :context="currentPage === maxPage ? 'primary' : 'default'" @click="currentPage = maxPage">{{ maxPage }}</Button>
        <ButtonSquare v-if="currentPage !== maxPage" icon="angle-right" @click="nextPage"/>
    </HorizontalAlignChildrenWrapper>
</template>

<style lang="scss" module>
    .ellipsis {
        display: flex;
        align-items: flex-end;
        padding: 0 .2em .8em .2em;
        font-size: .7em;
    }
</style>
